import {combineReducers} from 'redux';

import {default as listReducer} from './list';
import {default as detailReducer} from './detail';

const reducer = combineReducers({
  list: listReducer,
  detail: detailReducer
});

export const MODALS = {
  ADD_TEAM: 'addTeamModal',
  INVITE_NEW_STAFF_MEMBER: 'inviteNewStaffMember',
  TEAM_DETAILS: 'teamDetails',
  MANAGE_TEAM_PERMISSIONS: 'manageTeamPermissions',
  EDIT_TEAM_DETAILS: 'editTeamDetails',
  MANAGE_TEAM_LOCATIONS: 'manageTeamLocations',
  MANAGE_MEMBERS: 'manageMembersModal',
  INVITE_NEW_TEAM_MEMBER: 'inviteNewTeamMember',
  STAFF_MEMBER_DETAIL_MODAL: 'staffMemberDetailModal',
  SET_INACTIVITY_LOGOUT: 'setInactivityLogout'
};

export default reducer;
export * from './list';
export * from './detail';
